<template>
  <card :title="$t('home')">
    <vue-dropzone 
      ref="componentDropzone" 
      id="dropzone" 
      class="col-12" 
      :options="dropzoneOptions" 
      :include-styling="false"
      v-on:vdropzone-files-added="checkFiles"
      v-on:vdropzone-removed-file="checkFiles"
      v-on:vdropzone-queue-complete="queueComplete" 
      v-on:vdropzone-error="failed"
      :useCustomSlot=true>
      <div class="dropzone-custom-content">
        <h3 class="dropzone-custom-title">Dra och släpp här för att ladda upp</h3>
        <div class="subtitle">...eller klicka här för att välja filer.</div>
      </div>
    </vue-dropzone>

    <template slot="footer">
      <div class="d-flex">
        <div class="text-left d-flex">
          <select class="form-control" v-model="category_id" @change="setCategory">
            <option value="">Välj kategori</option>
            <option v-for="category in category_tree" :key="category.value" :value="category.value" v-html="category.label" />
          </select>

          <div class="form-check form-check-inline ml-2">
            <label class="form-check-label d-block text-nowrap" @click="updateOverwrite">
              <input class="form-check-input" type="checkbox" v-model="overwrite">
              Tvinga skriv över?
            </label>
          </div>

          <div class="form-check form-check-inline ml-2">
            <label class="form-check-label d-block text-nowrap" @click="updateRotate">
              <input class="form-check-input" type="checkbox" v-model="rotate">
              Rotera komponenter -90°?
            </label>
          </div>
        </div>
        <div class="text-right ml-auto">
          <button class="btn btn-danger" v-if="dropzoneHasFiles" @click="emptyQueue">Rensa kö</button>
          <button class="btn btn-success" :disabled="!category_id" @click="processQueue">Starta uppladdning</button>
        </div>
      </div>
    </template>
  </card>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import axios from 'axios'
import $ from 'jquery'
import 'select2'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
  middleware: 'auth',
  components: {
    vueDropzone: vue2Dropzone
  },
  created(){
    this.fetchData()
  },
  data(){
    return {
        dropzoneHasFiles : false,
        category_id : '',
        category_tree: [],
        overwrite : true,
        rotate: false,
        dropzoneOptions: {
            url: '/api/component',
            thumbnailWidth: 150,
            paramName: 'attachment',
            autoProcessQueue : false,
            addRemoveLinks : true,
            timeout: 180000,
            params : {
                'category_id' : this.category_id,
                'overwrite' : true,
                'rotate' : false,
            },
            dictRemoveFile : 'Ta bort',
            dictCancelUpload : 'Avbryt',
            dictResponseError : 'Ett fel uppstod {{statusCode}}'
        }
    }
  },
  methods : {
    failed:function(file,response,xhr){
      file.previewElement.getElementsByClassName('dz-error-message')[0].innerHTML = this.$t(response.message);
    },
    setCategory(){
      this.dropzoneOptions.params.category_id = this.category_id;
    },
    checkFiles(e){
        this.dropzoneHasFiles = this.$refs.componentDropzone.dropzone.files.length > 0;
    },
    updateOverwrite(){
      this.dropzoneOptions.params.overwrite = !this.overwrite;
    },
    updateRotate(){
      this.dropzoneOptions.params.rotate = !this.rotate;
    },
    emptyQueue(){
      this.$refs.componentDropzone.removeAllFiles();
    },
    processQueue(){
      this.$refs.componentDropzone.processQueue();
    },
    queueComplete(){
      this.updateSidebar();
      this.category_id = "";
      //this.emptyQueue();
    },
    updateSidebar(){
      let company = this.$store.getters['auth/company'];

      if(company.id){
        this.$store.dispatch('sidebar/fetchCategories',company.id);
      }
    },
    async fetchData(){
        let company = this.$store.getters['auth/company'];

        const { data } = await axios.get('/api/category?company_id=' + company.id);
        this.category_tree = data;
    }
  },
  metaInfo () {
    return { title: this.$t('component') }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/components/form.vue